import { graphql } from "../generated";

export const GetAudio = graphql(
  `
    query GetAudio($callId: ID!, $callType: AudioType!) {
      getAudio(callId: $callId, callType: $callType) {
        ...CallAudio
        ... on GenericException {
          ...BaseException
        }
        ...InsufficientPermissionException
      }
    }
  `
);
